import React from "react";
import "./HeroSection.css";
import TaglineScroller from "./TaglineScroller";

const HeroSection = ({ name, amount }) => {
  return (
    <section className="hero">
      <div className="background-container">
        {/* <div className="bg-image bg-one"></div>
        <div className="bg-image bg-two"></div> */}
      </div>
      <h1 className="main-heading2-pre">
        {name
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ")}
      </h1>
      <h1 className="main-heading3-pre">
        Your Pre-Approved Loan of ₹{amount.toLocaleString("en-IN")} is Ready!
      </h1>
      <p className="main-heading4">
        Instant approval, low interest rates, fully
        <br /> digital journey
      </p>
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <hr className="small-line-pre" />
      </div>
    </section>
  );
};

export default HeroSection;
